import * as React from 'react'
import { ProfilePage } from './ProfilePage'
import { ApplicationState } from '../../reducers'
import Auth, { CognitoUser } from '@aws-amplify/auth'
import { CognitoUserAttribute } from 'amazon-cognito-identity-js'
import bind from 'bind-decorator'
import { isLoggedInSelector } from './reducer'
import { awsToPhone } from '../../components'
import { connect } from 'react-redux'

type Props = {
    isLoggedIn: boolean
}

type State = {
    currentUser: CognitoUser | undefined
    firstName: string
    lastName: string
    gender: string
    email: string
    mobile: string
    address: string
    marketing: string
}

class ProfilePageLoad extends React.Component<Props> {
    readonly state: State = {
        currentUser: undefined,
        firstName: '',
        lastName: '',
        gender: '',
        email: '',
        mobile: '',
        address: '',
        marketing: '',
    }

    componentDidMount() {
        this.prepareUser()
    }

    getAttributeByName(name: string, attributes: CognitoUserAttribute[]) {
        const attribute = attributes.find(attribute => attribute.getName() === name)

        return attribute ? attribute.getValue() : ''
    }

    @bind
    async prepareUser() {
        if (!this.props.isLoggedIn) {
            return
        }

        const user = await Auth.currentAuthenticatedUser()

        if (!user || !(user as CognitoUser).getUserAttributes) {
            return
        }

        this.setState({ currentUser : user })

        const attributes = await new Promise<CognitoUserAttribute[]>((resolve, reject) => {
            (user as CognitoUser).getUserAttributes((err, attributes) => {
                if (err) {
                    reject(err)
                    return
                }

                resolve(attributes)
            })
        })

        this.setState({
            firstName: this.getAttributeByName('given_name', attributes),
            lastName: this.getAttributeByName('family_name', attributes),
            gender: this.getAttributeByName('gender', attributes),
            email: this.getAttributeByName('email', attributes),
            mobile: awsToPhone(this.getAttributeByName('phone_number', attributes)),
            address: this.getAttributeByName('address', attributes),
            marketing: this.getAttributeByName('custom:marketing_opt_in', attributes),
        })
    }

    render() {
        const {
            currentUser,
            firstName,
            lastName,
            gender,
            email,
            mobile,
            address,
            marketing,
        } = this.state

        return (
        <>
            {currentUser !== undefined ?
                <ProfilePage
                    currentUser={currentUser}
                    firstName={firstName}
                    lastName={lastName}
                    gender={gender}
                    email={email}
                    mobile={mobile}
                    address={address}
                    marketing={marketing}
                    refresh={this.prepareUser}
                /> : ''
            }
        </>
        )
    }
}

const mapStateToProps = (state: ApplicationState): Props => ({
    isLoggedIn: isLoggedInSelector(state),
})

const ProfilePageWithData = connect(mapStateToProps)(ProfilePageLoad)

export { ProfilePageWithData }
